
export const selectUser=(state)=>state.user.user

export const selectUsersList=(state)=>state.user.list